import { PedidoFilter } from './pedido-filter';

export class PedidoFilterStorage {
    filter: PedidoFilter;
    filterValues: Map<string, any>;

    constructor(filter: PedidoFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
